import { useI18n } from "vue-i18n";

export const useLocale = () => useI18n({ useScope: "global" });
